import classNames from "classnames";
import styles from "./tabs.module.css";

const Tabs = (data) => {
  const tabArray = data?.tabs ? Object.values(data?.tabs) : [];
  return (
    <div className={styles.tabContainer}>
      {tabArray.map((tab) => (
        <div
          className={classNames(styles.tab, { [styles.active]: tab?.active })}
          key={tab?.id}
          onClick={tab?.onClick}
        >
          {tab?.label}
        </div>
      ))}
      <div className={styles.tabSpacer} />
    </div>
  );
};

export default Tabs;
